export default "__VITE_ASSET__CM2psNLx__"